/**
 * sm-embed.js
 * Two small jobs, no dependencies, no framework.
 *
 * 1. Lazy loads embedded form iframes. The iframe carries data-sm-src and no
 *    src, so nothing is requested until the section approaches the viewport.
 *    An embedded form above the fold otherwise costs a second of load on a
 *    page that is otherwise fast.
 * 2. Delegates click tracking for elements carrying data-sm-event, pushing
 *    to dataLayer. Every blueprint event is declared in section settings
 *    rather than hardcoded, so adding an event never requires a code change.
 *
 * Vignovic Agency - Schmear Bagel Parlor website build (EO run SI-WEB1)
 */
(function () {
  'use strict';

  function promote(frame) {
    if (frame.dataset.smLoaded) return;
    var src = frame.dataset.smSrc;
    if (!src) return;
    frame.dataset.smLoaded = 'true';
    frame.setAttribute('src', src);
  }

  function initEmbeds(root) {
    var frames = (root || document).querySelectorAll('iframe[data-sm-src]');
    if (!frames.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(frames, promote);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            promote(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '400px 0px' }
    );

    Array.prototype.forEach.call(frames, function (f) {
      io.observe(f);
    });
  }

  function onClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var el = target.closest('[data-sm-event]');
    if (!el) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: el.dataset.smEvent,
      parlor: el.dataset.smParlor || undefined,
      page_location: window.location.pathname
    });
  }

  document.addEventListener('click', onClick, { passive: true, capture: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initEmbeds(document);
    });
  } else {
    initEmbeds(document);
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', function (e) {
    initEmbeds(e.target);
  });
})();